import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys } from "./keys";

async function fetchReminder(id: string) {
  const { data, error } = await apiClient
    .from('reminders')
    .select()
    .eq('id', id)
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export default function useGetReminder(id: string, enabled?: boolean) {
  return useQuery({
    queryKey: keys.detail(id),
    queryFn: () => fetchReminder(id),
    enabled: enabled && !!id,
  });
}
